import React,{ Component, Fragment } from "react";
import { connect } from 'react-redux';
import { socketConnect } from 'socket.io-react';
import { getArrays, intersect } from 'lib';
import PropTypes from 'prop-types';
import moment from 'moment';
import { setCheckoutPlanParams, updateCheckoutPlanParams } from 'store/checkoutPlanParams';
import { setCheckoutMealPlan,updateCheckoutMealPlan } from 'store/checkoutMealPlan';
import { userUpdate } from 'store/user';
import { setModal } from 'store/modal';
import { spin, stop } from 'store/spinner'; 
import Tabs from 'components/Checkout/Customfit/Tabs';
import BottomNav from 'components/Checkout/BottomNav';
import Select from 'components/Select';
import MealEdit from 'components/Checkout/Customfit/CustomfitEdit';
import CheckIcon from 'assets/checkDiet.png';
import { browserHistory } from "react-router";
import InputCalendar from 'components/InputCalendar';
import OrderSummary from 'components/Checkout/OrderSummary';
class Process extends Component{

    constructor(props) {
        super(props);
        const { checkoutPlanParams,dataArray } = this.props;
        const { id:checkoutId,mealTypes:prevMealType, days_count, mealPlan_id:mealPlan,diet_id,exclude_week_day,defaultDish, priceDatas, bag_price, cutlery, couponCode } = checkoutPlanParams || {};
        if(checkoutId) browserHistory.push('/checkout/menus');
        const { mealtypeMobCombinations } = dataArray;
        let minVal =moment().utc().add(4,'days').utc().startOf('day');
        let comb= (prevMealType && mealtypeMobCombinations && mealtypeMobCombinations[prevMealType.join('-')]!=undefined) ?mealtypeMobCombinations[prevMealType.join('-')]:false;
        let rangeId = this.getDayRangeId(days_count);
        this.state={
            diet:'',
            planParams:{
              diet:'',
              pricetype:0,
              mealType:prevMealType|| [],
              dayCount:days_count || 20,
              mealPlan_id:mealPlan || null,
              defaultDish:defaultDish||[],
              exclude_week_day:exclude_week_day || [],
              priceDatas:priceDatas || {couponCode:'',discountPrice:'',discountPer:'',discountType:'',discountTypeCoupon:'',discountPriceCoupon:'',discountPerCoupon:''},
              cutlery:cutlery || 0,
              bag_price:bag_price || 180,
              emirate_id:'',
              slot_id:'',
              coupon_id:'',
              couponCode:couponCode || '',
              deliveryDate:minVal.unix()
            },
            dishList:[],
            mealTypeList:[],
            mealType:prevMealType|| [],
            dayCount:days_count || 20,
            selectedDay:(days_count>0 && ![5,6,20,24,30,40,60].includes(parseInt(days_count)))?{label:days_count+' Days',value:days_count}:[],
            excluded:exclude_week_day || [],
            mealplanId:mealPlan || null,
            dayRangeId:rangeId || null,
            mealTypeCom:comb || null,
            defaultDish:defaultDish||[],
            errors:[],
            priceDatas:priceDatas || {couponCode:'',discountPrice:'',discountPer:'',discountType:'',discountTypeCoupon:'',discountPriceCoupon:'',discountPerCoupon:''},
            bag_price:bag_price || 180,
            cutlery:cutlery || 0,
            paymentMethod:'not_paid',
            coupon:{},
            couponCode:couponCode || '',
            couponError:[],
            addOnPrice:0,
            customPrice:0,
            clearPrice:0,
            emirate:'',
            emirate_id:'',
            slot:'',
            slotList:'',
            slot_id:'',
            deliveryDate:minVal.unix(),
            emirateList:[],
            addonMealTypeList:[],
            customfitConfig:{}
        }
    }

    componentDidMount(){
        const { socket } = this.props;
        if(socket.connected){
            this.initializeData();
        }else{
            socket.on('connect', (data) => {
                this.initializeData();
            });
        } 
    }
    getDayRangeId = (count) =>{
        const { dataArray } = this.props;
        const { daysRangeMob } = dataArray;
        count=parseInt(count);
        let rangeId=0;
        daysRangeMob && Object.keys(daysRangeMob).forEach((mealplanId, index) => {
              const { min:minVal, max:maxVal } = daysRangeMob[mealplanId] || {};
              if(parseInt(minVal)<=count && parseInt(maxVal)>=count){
                rangeId=mealplanId;
                return mealplanId;
              }
        });
        return parseInt(rangeId);
    }
    initializeData =() =>{
      
        const { socket, dataArray,user } = this.props;
        this.getCustomFitSettings();
        const types = ['productsList','dietMobileList','dietListFull','dishGroups','planDayRange','daysRangeMob','mealtypeMobCombinations','typeList','customfitDishsList','customFitCategory','emirate','emirateSlots','priceList'].filter(el => !(el in dataArray));
        if(types.length>0){
            this.props.spin();
            getArrays(socket, types);
        }
        this.getPending(user.user_id);
        this.initializeStateData(dataArray);
    }

    initializeStateData(dataArray){

      const { customfitDishsList, dietListFull, typeList, emirate, emirateSlots } =dataArray;
      const { defaultDish,diet,planParams } = this.state;
      let mealtype_ids =(dietListFull!=undefined && dietListFull[diet]!=undefined)?dietListFull[diet].mealtype_ids:[];
    
      let dishList =[];
      let defaultDishVal =[];
      customfitDishsList && Object.keys(customfitDishsList).map((cat, index, acc) => {
        const dayData = Object.keys(customfitDishsList[cat]).reduce((acc, id) => {
          return { ...acc, [+id]:  customfitDishsList[cat][id].title };
        }, {});
        dishList[cat]=dayData;
        defaultDishVal[cat]={};
      });
     
      const emirateList = emirate!=undefined && Object.keys(emirate).map((val)=>{
            return {label:emirate[val],value:val};
        });
        const slotList =[]; 
        (emirateSlots && emirate && emirateSlots[emirate]) && emirateSlots[emirate].reduce((obj, key) => {
          slotList.push({label:key.display_name,value:key.id});
        }, []);
    
      planParams.defaultDish=(defaultDish!=undefined && defaultDish.length>0)?defaultDish:defaultDishVal;
      this.setState({defaultDish:planParams.defaultDish,dishList:dishList,emirateList:emirateList,slotList},()=>{this.updateMealPlanId()});
    }
    componentWillReceiveProps(next) {
     
      if(Object.keys(this.props.dataArray).length!==Object.keys(next.dataArray).length){
         this.initializeStateData(next.dataArray);
      }
    }

    componentWillMount() {
      this.props.socket.emit('join', {room: 'user_id_'+this.props.user.user_id});
      this.props.socket.on('mobile_checkout', this.listener);
      this.props.socket.on('profile', this.listener);
      this.props.socket.on('settings', this.listener);
    }

    componentWillUnmount() {
      this.props.socket.removeListener('mobile_checkout', this.listener);
      this.props.socket.removeListener('profile', this.listener);
      this.props.socket.removeListener('settings', this.listener);
    }

    getCustomFitSettings= () =>{
      this.props.socket.emit('settings', { type: 'getCustomfit', data: {} });
    }
    getPending = user_id => this.props.socket.emit('mobile_checkout', { type: 'getPending', data: { user_id } });

    saveProfile = (data,action) =>{
        const { user } = this.props;
        this.props.socket.emit('profile', { type: 'getForDashboard', data: { userId: user.user_id, subtype: 'saveProfDataMobile', theaction: action, value: data,deviceType:'web'} });
    }

    listener = ({ type, data, message }) => {
        this.props.stop(); 
        const { setCheckoutPlanParams, setCheckoutMealPlan } = this.props;
        switch (type) {
           case 'saveProfDataMobileOk':
            const { value,action } = data || {};
            let updateData = {};
            updateData[action] = value;
            this.props.updateUser(updateData);
           break;
           case 'getPendingOk':
              if(data && data.mealPlan !=undefined ){
                setCheckoutPlanParams(data.planParams);
                setCheckoutMealPlan(data.mealPlan);
                browserHistory.push('/checkout/menus');
              }
            break;
            case 'applyCouponCodeOk':
              const { error,message:msg, coupon } =data;
              if(error){
                let errorVal={};
                errorVal['couponCode']=msg;
                this.setState({couponCode:'',couponError:errorVal,coupon:{}});
              }else{
                this.setState({couponError:[],coupon:coupon});
                // this.applyCoupon(); 
              }
            break;
            case 'setOk':
             
              if(data.planParams!=undefined){
                setCheckoutPlanParams(data.planParams);
                setCheckoutMealPlan(data.mealPlan);
              }
              browserHistory.push('/checkout/menus');
            break;
            case 'getCustomfit':
              const { planParams } = this.state;
              const { diet_id,preset_mealtype_ids,main_mealtype_ids } = data;
                this.setState({customfitConfig:data,diet:diet_id,planParams:{diet:diet_id,...planParams},mealTypeList:main_mealtype_ids,addonMealTypeList:preset_mealtype_ids});
            break;
            case 'setErr':
              console.log(message);
            break;
           default:
           break;
        }
    }
    applyCoupon(){
        const priceDatas = {price:0,discountPrice:0,discountPriceCoupon:0,discountPer:0,discountType:'',discountPerCoupon:0,savedCouponAmount:0,couponCode:'',discountTypeCoupon:'',voucher_id:'',voucher_field:''};
        const {  coupon, clearPrice } = this.state;
       
        if(coupon){
          const { type,value,code,apply_type } = coupon;
          priceDatas.couponCode=code;
          priceDatas.discountTypeCoupon=type;
          priceDatas.discountPerCoupon=(type == 'percent')?value:value/100; 
          if(apply_type=='mainprice'){
            priceDatas.discountPriceCoupon =(type == 'percent')?clearPrice-((value/100) * clearPrice):clearPrice-value;
            priceDatas.savedCouponAmount=clearPrice-priceDatas.discountPriceCoupon;
          }else{
            let { discount:discountVal,discountPer:discountPerVal, discountType:discountTypeval,voucher_id:voucherId }=this.getVoucherDiscount(clearPrice);
            priceDatas.voucher_id=voucherId;
            priceDatas.discount=discountVal;
            priceDatas.discountPer=discountPerVal;
            priceDatas.discountType=discountTypeval;
            priceDatas.discountPrice =(discountVal>0)?clearPrice - discountVal:clearPrice;
            priceDatas.discountPriceCoupon =(type == 'percent')?priceDatas.discountPrice-((value/100) * priceDatas.discountPrice):priceDatas.discountPrice-value;
            priceDatas.savedCouponAmount=priceDatas.discountPrice-priceDatas.discountPriceCoupon;
          }
        }else{
          let { discount:discountVal,discountPer:discountPerVal, discountType:discountTypeval,voucher_id:voucherId }=this.getVoucherDiscount(clearPrice);
          priceDatas.voucher_id=voucherId;
          priceDatas.discount=discountVal;
          priceDatas.discountPer=discountPerVal;
          priceDatas.discountType=discountTypeval;
          priceDatas.discountPrice= clearPrice - priceDatas.discount;
        }
        // console.debug(priceDatas);

        this.setState({priceDatas:priceDatas});
    }
    getVoucherDiscount(clearPrice){
      let discount = 0;
      let discountPer = 0;
      let discountType = 0;
      const {  dataArray } = this.props;
      const { dietMealTypeDiscounts, commonVouchers } = dataArray;
      const { dayRangeId, mealTypeCom, mealType, diet, dayCount } = this.state;
      let combo = (dietMealTypeDiscounts!=undefined && dietMealTypeDiscounts[+diet]!=undefined && dietMealTypeDiscounts[+diet][mealTypeCom]!=undefined && dietMealTypeDiscounts[+diet][mealTypeCom][dayRangeId]!=undefined)?dietMealTypeDiscounts[+diet][mealTypeCom][dayRangeId]:'';
        const vou = commonVouchers && commonVouchers.find(({ id }) => +id === +combo);
        if(combo && vou != undefined){
            let isMealTypeDis =0;
            // const vou = commonVouchers[combo];
            /* Apply the discount based meal types */
            if(vou && vou.conditions!=null && vou.conditions!='' ){
              vou.conditions =(typeof vou.conditions === 'string' || vou.conditions instanceof String )?JSON.parse(vou.conditions):vou.conditions;
              isMealTypeDis=intersect(mealType,vou.conditions).length;   
            }
            discount = (vou && vou.conditions!=null && vou.conditions.length>0 && isMealTypeDis)?this.calcPrice(vou.conditions,dayCount):(vou ? (vou.type === 'fixed' ? +vou.value : (vou.type === 'percent' ? (+vou.value / 100) * clearPrice : 0)) : 0);
            discountPer = +vou.value;
            discountType = vou.type;
        }
      return {discount,discountPer,discountType,voucher_id:(vou || {}).id};
    }

    checkIsAllergiesOrDislike=(productsList,allergies,dislikes,dishid)=>{
      const { ingredients }= productsList?productsList[dishid] || {}:{};
      let is_allergies=false;
      if(ingredients!=undefined&&ingredients.length>0){
          if (allergies.length>0) {
            is_allergies = intersect(ingredients,allergies).length;
          }
          if(dislikes.length>0&&!is_allergies){
            is_allergies = intersect(ingredients,dislikes).length;   
          }
          if(!is_allergies){
            return  dishid;
          }
          return  null;
        }else{
          return  dishid;
        }
    };

    fillPlanDates = (startDate, count, excludedDays) => {
      startDate =startDate;
      excludedDays =(excludedDays)?excludedDays:[];
      const includedDays = Array(7).fill(0).map((el, key) => key).filter(el => !excludedDays.includes(String(el)));
      let dates = {};
      if(count>0 && startDate){
          for (let i = 0; i < count; i++) {
            startDate = moment.unix(this.getinitialDate(includedDays,(i==0)?startDate:startDate+3600*24)).unix();
            dates[startDate] = {};
          }
      }
      return dates;
    };
    
    fillDefaults = (mealPlan) => {
      const { mealType: types, defaultDish,addonMealTypeList } = this.state;
      const { dataArray, user,customPlans, defaultDishes } = this.props;
      let newmealType=types;      
      const { productsList, typeList, customFitCategory } = dataArray;
     
      const getDish = (date, type,existDish) => {
       
        const day = moment.unix(date).date() - 1; // TODO: check logic
        const sameDayDish = Object.values(existDish);
        
        const plan = customPlans.find(el => +el.mealType_id === +type) || {};
        let dish=+(defaultDishes[+type] || {})[day] || null;
        /* Start Disable the dislike/allergies dish */
          let prodKeys = (plan.data || {})[day] || [];
  
          const {allergies,dislikes,dishdislikes,eliminate_groups}=user;
  
          let is_allergies=this.checkIsAllergiesOrDislike(productsList,allergies,dislikes,dish);
  
          if(eliminate_groups.length>0 && is_allergies){
          
            const { group,spicy } =productsList[dish] || {};
            // is_allergies=(eliminate_groups.indexOf(group)>-1)?null:dish;
            is_allergies=(intersect(group,eliminate_groups).length>0)?null:dish;
            if(is_allergies){
              is_allergies=(eliminate_groups.indexOf(14)>-1 && spicy==1)?null:dish; // Spicy Group and dish set as spicy
            }
           
          }
  
          if(dishdislikes.length>0 && is_allergies){
            is_allergies=(dishdislikes.indexOf(dish)>-1)?null:dish;
          }
          if(sameDayDish.length>0 && is_allergies){
            is_allergies=(sameDayDish.indexOf(dish)>-1)?null:dish;
          }
          if(is_allergies!=null){
            return +dish;
          }else{
            prodKeys=prodKeys.filter(function (dishId) {
                const { group,spicy } = productsList[dishId] || {};
                let isEliminate = true;
                if(eliminate_groups.length>0){ 
                  // isEliminate = !(eliminate_groups.indexOf(group)>-1); 
                     isEliminate = !intersect(group,eliminate_groups).length;   
                  if(isEliminate){
                     isEliminate=!(eliminate_groups.indexOf(14)>-1 && spicy==1); // Spicy Group and dish set as spicy
                  }
                }
                if(dishdislikes.length>0 && isEliminate){
                  isEliminate = !(dishdislikes.indexOf(+dishId)>-1); 
                }
                return +isEliminate;
            });
            
            let validDish = prodKeys.find((dishId, idx) => {
              if(dishId!=dish){
                let is_allergies=this.checkIsAllergiesOrDislike(productsList,allergies,dislikes,dishId);
                if(sameDayDish.length>0 && is_allergies){
                  is_allergies=(sameDayDish.indexOf(dishId)>-1)?null:dishId;
                }
                if(is_allergies!=null||(prodKeys.length-1)==idx){
                  return +dishId;
                }
              }
            });
            return (validDish != undefined )?validDish:+dish; // Set default dish,If the all dish are dislike/allergies
          }
         /* End Disable the dislike/allergies dish */
  
      };
      const validateMealPlan ={};
      const checkoutMealPlan = Object.keys(mealPlan).reduce((acc, date) => {
        const dayData = newmealType.reduce((acc, type) => {
          if(addonMealTypeList.includes(type.toString())){
            let dishId = getDish(date, type,acc);
            if(!dishId){
              validateMealPlan[date]={...validateMealPlan[date]};
              validateMealPlan[date][type]="Missing the default dish. Please choose different preset meal type.";
            }
             return { ...acc, [+type]:dishId  };  
          }else{
              // const catData = customFitCategory!=undefined && Object.keys(customFitCategory).reduce((acc2, catId) => {
              //       return {...acc2, [+catId]:defaultDish[catId][type]};
              // }, {});
            return { ...acc, [+type]: defaultDish[type] };  
          }
        }, {});
        
        return { ...acc, [+date]: dayData };
      }, {});
      return {checkoutMealPlan:checkoutMealPlan,validateMealPlan:validateMealPlan}
    };

    getinitialDate=(includedDays,startDate)=>{
      let initialDate = moment.unix(startDate);
      if(includedDays.includes(initialDate.weekday())){
        return startDate;
      }else{
         return this.getinitialDate(includedDays,startDate+3600*24);
      }
    };
    getValidDate = (initdate,excludedDays) =>{
          if(excludedDays && excludedDays.length>0 && excludedDays.length<7){
              if(excludedDays.includes(initdate.day())||excludedDays.includes(String(initdate.day()))){
                return this.getValidDate(initdate.add(1,'day'),excludedDays);
              }else{
                return initdate;
              }
          }else{
            return initdate;
          }
    } 
    updateValidateDate =()=>{
        const { deliveryDate, excluded } = this.state;
        let reDate = this.getValidDate(moment.unix(deliveryDate),excluded).unix();
        this.setState({deliveryDate:reDate});
    }
    updateEmirateSolts = () =>{
      const { dataArray } = this.props;
      const { emirateSlots } = dataArray;
      const { emirate_id } = this.state;
      const slotList =[];
       (emirateSlots && emirate_id && emirateSlots[emirate_id]) && emirateSlots[emirate_id].reduce((obj, key) => {
          slotList.push({label:key.display_name,value:key.id});
      }, []);
     
      this.setState({slotList,slot:[],slot_id:''});
  }
    renderDates(){
        const { deliveryDate, emirate,slot, emirateList,slotList, minDate, excluded, errors } = this.state;
        const { dataArray } = this.props;
        const { emirate:emirateArray,emirateSlots } = dataArray;
        const emirateList1 =( emirateArray!=undefined && emirateList.length==0)?Object.keys(emirateArray).map((val)=>{
            return {label:emirateArray[val],value:val};
        }):emirateList;
        const slotList1 =(slotList.length==0)?(emirateSlots && emirate && emirateSlots[emirate]) && emirateSlots[emirate].reduce((obj, key) => {
          return {label:key.display_name,value:key.id};
      }, []):slotList;
         
        let newDate = moment().utc().add(3,'days');
        const renderDay = (props, currentDate) => {
            if (!currentDate.isBetween(newDate, newDate.clone().add(3, 'months'), null, '[]') || excluded.includes(String(currentDate.days()))) {
              props.className = `${props.className} rdtDisabled`;
              delete props.onChange;
              delete props.onClick;
            } else if (currentDate.isSame(deliveryDate || newDate)) {
              props.className += ' selected';
            }
            return <td {...props}>{currentDate.date()}</td>;
          };
          const today = moment();
        !today.isUTC() && today.utc();
        today.startOf('day');
        
        
        return <div className="step-form-group date-locations">
            <div className="step-form-group date-locations-top">
            <div className="popup-select-area step-form-input">
                <label className="food-prefs-header">Start Date</label>
                <div className="popup-dash-calendar-fix">
            <InputCalendar
                inputClassName='letter-xs pointer'
                locale='en'
                value={deliveryDate || newDate.unix()}
                dateFormat={'YYYY-MM-DD'}
                name='deliveryDate'
                // before={minDate}
               renderDay={renderDay}
                onViewModeChange={() => false}
               // onNavigateBack={(amount, type, curDate) => moment().utc().startOf(type).isBefore(curDate.utc())}
                onChange={val => this.setState({ deliveryDate: val },()=>{this.updateValidateDate()})}
                placeholder='Select start date'
              />
              </div>
            </div>
            <div className="popup-select-area step-form-input">
                <label className="food-prefs-header">Emirates</label>
                <div className={'className'}>
                 <Select
                            multiple={false}
                            isgrouped={true}
                        placeholder='Select Emirates'
                        list={emirateList1 || []}
                        value={emirate || ''}
                        isSearchable={true}
                        name='selectedDay'
                        onChange={ (name, val) => {
                        
                        // this.changeDislike('dislikes', val);
                        this.setState({
                            emirate_id: val.value,
                            emirate:val
                        },()=>{ this.updateEmirateSolts();});
                        }}
                        />
                    </div>
              {'emirate_id' in errors&&this.renderErrorMsg(errors['emirate_id'])}
            </div>
            <div className="popup-select-area step-form-input">
                <label className="food-prefs-header">Delivery  Time</label>
                <div className={'className'}>
                 <Select
                            multiple={false}
                            isgrouped={true}
                        placeholder='Select Delivery  Time'
                        list={slotList1|| []}
                        value={slot || ''}
                        isSearchable={true}
                        name='selectedDay'
                        onChange={ (name, val) => {
                         
                        // this.changeDislike('dislikes', val);
                        this.setState({
                        slot_id: parseInt(val.value),
                        slot: val
                        });
                        }}
                        /> 
                    </div>
                {'slot_id' in errors&&this.renderErrorMsg(errors['slot_id'])}   
            </div>
            </div>  
            <p>*Please note the delivery will happen any time within the selected  delivery time window.</p>          
        </div>
    }
    _addMealTypes = (item) =>{
        const { dataArray,checkoutPlanParams }= this.props;
        const { diet_id:diet } = checkoutPlanParams;
        const { typeList,dietListFull } = dataArray;
          const { mealType } = this.state;
          const { children } = typeList[+item];
          let selected = [];
          if (mealType.includes(+item)) {
            selected = mealType.filter(
              (meal) => meal !== +item
            );
            if(children && dietListFull[diet] && dietListFull[diet].sides_id!=null){
              selected = selected.filter(el => el != +children.id);
            }
          }else{
            selected =[...mealType,+item];
            if(children && dietListFull[diet] && dietListFull[diet].sides_id!=null){
              selected = [...selected, (+children.id)];
            }
          }
          selected.sort(); 
          this.setState({'mealType':selected},() => {this.updateMealPlanId()});
      }
      getMealPlanId= (count) =>{
        const { dataArray } = this.props;
        const { planDayRange } = dataArray;
        count=parseInt(count);
        let planId=0;
        planDayRange && Object.keys(planDayRange).forEach((mealplanId, index) => {
              const { range_from, range_to } = planDayRange[mealplanId] || {};
              if(parseInt(range_from)<=count && parseInt(range_to)>=count){
                planId=mealplanId;
                return mealplanId;
              }
        });
        return parseInt(planId);
      }

    updateMealPlanId = ()=>{
        const { dataArray } = this.props;
        const { diet:diet_id, dayCount, mealType } = this.state;
        const { mealtypeMobCombinations, typeList } = dataArray;
        const childTypes= mealType.map((val)=>{
          const { children } = typeList?typeList[+val]:'';
          return (children!=null)?children.id:null;
      }).filter((el)=>{ return el != null; });
      let mealTypeHandle= mealType.filter((el)=>{ return !childTypes.includes(el);}).sort(function(a, b) {
        return a - b;
      }).join('-');
        let comb= (mealtypeMobCombinations && mealtypeMobCombinations[mealTypeHandle]!=undefined) ?mealtypeMobCombinations[mealTypeHandle]:false;
        let mealP= this.getMealPlanId(dayCount);
        let rangeId = this.getDayRangeId(dayCount);
        this.getDefaultDishes(diet_id,mealType);
        this.setState({dayRangeId:rangeId,mealplanId:mealP,mealTypeCom:comb});
    }

    getDefaultDishes = (dietId, types) => { 
        this.props.socket.emit('default_dishes', { type: 'get', data: { dietId, types } });
        this.props.socket.emit('custom_plan', { type: 'get', data: { diet_id:dietId, mealTypes:types } });
    }
    validDefaultDish(){
      const { typeList } = this.props.dataArray;
      const { mealType, defaultDish, mealTypeList } = this.state;
      let error={};
      mealType && mealType.filter((value)=>mealTypeList.includes(value.toString())).map((val)=>{
        if(defaultDish[val]==undefined || Object.keys(defaultDish[val]).length<=0){
          error[val]='Please select protein value';
        }else{
          Object.keys(defaultDish[val]).map((ind)=>{
            const { dishId, qty } = defaultDish[val][ind];
            if(!dishId || !qty){
              error[val]='Please select protein value';
            }
         });
        }
      });
      return error;
    }
    validate = ()=>{
        
          const { diet, mealType, mealplanId,deliveryDate, slot_id, emirate_id, defaultDish, dayCount,excluded , cutlery, bag_price, couponCode, coupon, addonMealTypeList } = this.state;
          const { setModal } = this.props; 
          const required = ['mealTypes', 'diet_id','emirate_id', 'mealPlan_id', 'start_date', 'slot_id', 'days_count','defaultDish'];
          const errors = {};
          const { priceDatas } = this.getPrice();
          const planParams={
            diet_id:diet,
            mealTypes:mealType,
            days_count:dayCount,
            mealPlan_id:mealplanId,
            defaultDish:defaultDish,
            exclude_week_day:excluded,
            priceDatas:priceDatas,
            cutlery:cutlery,
            bag_price:bag_price,
            emirate_id,
            slot_id,
            couponCode:couponCode,
            coupon:coupon,
            coupon_id:coupon?coupon.id:'',
            start_date:deliveryDate
          }
          let flag = false;
          let addonMealType=(mealType.length>0)?mealType.filter((el)=>{ return (addonMealTypeList.indexOf(el)==-1);}):[];
       
          required.forEach(el => {
          
          if(el=='mealTypes' && addonMealType.length<=0){
            errors[el] = 'This field is required'; 
            flag = true;
          }
            if (!(el in planParams) || !planParams[el]) {
            
              if (el != 'Price' && planParams[el] !== 0) {
                errors[el] = 'This field is required';
                flag = true;
              }else if(el=='mealTypes' && addonMealType.length<=0){
                errors[el] = 'This field is required'; 
                flag = true;
              }else if(el=='defaultDish'){
                errors[el] = this.validDefaultDish(planParams);
                if(Object.keys(errors[el]).length>0){
                  flag = true;
                }
              }
            }else if(el=='mealTypes' && planParams[el].length<=0){
              errors[el] = 'This field is required';
              flag = true;
            }else if(el=='defaultDish'){
              errors[el] = this.validDefaultDish(planParams);
                if(Object.keys(errors[el]).length>0){
                  flag = true;
                }
            }
          });
          if (flag) {
            this.setState({ errors });
          } else {
            const { start_date, days_count, exclude_week_day} = planParams;
            this.getDefaultDishes(diet, mealType);
            let mealPlan = this.fillPlanDates(start_date, days_count, exclude_week_day);
            const { checkoutMealPlan, validateMealPlan} = this.fillDefaults(mealPlan);
            // this.setState({ step: 2, mealPlan });
            // console.info('mealPlan');
            // console.info(mealPlan);
            // console.info(checkoutMealPlan);
            // console.info(validateMealPlan);
            if(Object.keys(validateMealPlan).length<=0){
                this.savePlan(checkoutMealPlan,planParams);
            }else{
              setModal({ headLine: 'Preset meal type error', message:'Missing the default dish. Please choose different preset meal type.'});
            }
            
          }
    }
    savePlan = (checkoutMealPlan, planParams) =>{
      const { user } =this.props;
      const { priceDatas, slot_id, emirate_id  } = planParams;
    
      let checkDates = Object.keys(checkoutMealPlan);
      let checkOutdata ={...planParams,user_id:user.user_id,price:((priceDatas.discountPriceCoupon>0)?priceDatas.discountPriceCoupon:(priceDatas.discountPrice>0?priceDatas.discountPrice:priceDatas.price)),full_price:priceDatas.price,discount_price:priceDatas.savedAmount,slot_id:slot_id,emirate:emirate_id,start_date:checkDates[0],end_date:checkDates[(checkDates.length)-1]};
     
      this.props.socket.emit('mobile_checkout', { type: 'set',   data: {
        checkoutPlanParams:checkOutdata,
        detailsData: checkoutMealPlan
      }});
     
      // props.stop();
   }
    renderErrorMsg(msg){
        return <p className='has-error' style={{ fontSize: 'small',textAlign:'left',position:'relative',color:'#d57669'}} customColor='#f44336'>{msg}</p>;
    }
    
    renderMealBuild() {
        const { dataArray } = this.props;
        const {  mealType, mealTypeList, errors } = this.state;
        const { typeList } = dataArray;
        const list= typeList && mealTypeList && mealTypeList.map((item,index)=>{
                return <li className={`diet-list meal-type-l ${(mealType.includes(+item)) ? 'diet-active' : ''}`} onClick={() => this._addMealTypes(+item)}>
                    <span>{typeList[item].title}</span>
                    <span class="checkbox"></span>
                </li>
        });
        return <div className="step-form-input meal-choose">
            <span className="span-label">Select CustomFit Main Meals & Build Combinations</span>
            <ul className="checkout-diet-list">
            {list}
        </ul>
        {'mealTypes' in errors&&this.renderErrorMsg(errors['mealTypes'])}
        </div>;
    }

    changeDefaultValues = (catId, currentType, name,value) => {
         const { customfitDishsList } =  this.props.dataArray;
         this.setState(prevState => {
          const newDefaultDish = { ...prevState.defaultDish };
          newDefaultDish[currentType] = { ...prevState.defaultDish[currentType] };
          newDefaultDish[currentType][catId]={
            ...newDefaultDish[currentType][catId],
            [name]: value
          };
          if(name=='dishId'&&newDefaultDish[currentType][catId]['qty']==undefined){
            newDefaultDish[currentType][catId]['qty']=0;
          }
          if(newDefaultDish[currentType][catId]['dishId']!=undefined && newDefaultDish[currentType][catId]['dishId']!=0 && newDefaultDish[currentType][catId]['dishId']!=''){
          let dish=customfitDishsList[catId][newDefaultDish[currentType][catId]['dishId']];
          let basePrice =(dish.base_price>0)?(dish.base_price/100):0;
            newDefaultDish[currentType][catId]['price']=this.roundUpValue(basePrice+((newDefaultDish[currentType][catId]['qty']/100)*(dish.price/100)));
          }
          if(newDefaultDish[currentType][catId]['dishId']==0 || newDefaultDish[currentType][catId]['dishId']=='' && (newDefaultDish[currentType][catId]['dishId']!=0 && newDefaultDish[currentType][catId]['dishId']!='' && newDefaultDish[currentType][catId]['qty']<=0)){
            delete newDefaultDish[currentType][catId];
          }
          return { defaultDish: newDefaultDish };
        });
   };
    roundUpValue=(value)=>{
      return Math.round(value * 100) / 100;
    }
    calculateMacros=(val,qty)=>{
        let macro = (val/100) * qty;
        return this.roundUpValue(macro);
    }
    renderEditMeals() {
        const { errors, defaultDish , mealType, dishList, mealTypeList } = this.state;
        const { dataArray } = this.props;
        const { customFitCategory, customfitDishsList, typeList} =  dataArray;
        
        console.debug('mealType');
        console.debug(mealType);
        console.debug(mealTypeList);
        const error = ('defaultDish' in errors)?errors.defaultDish:{};
        const meals = mealType && customFitCategory && mealTypeList.filter((value)=>mealType.includes(parseInt(value))).map((val)=>{
          let totalprice=0; 
          let tcalories=0,tprotein=0,tcarb=0,tfat=0;
            return <div className="customfit-contanier" style={{marginTop:'10px',marginBottom:'10px'}}>
                    <div className="customfit-title" >
                        <p className='title-heading' bold style={{ fontSize: 'large' }} customColor='#555'>{typeList[val].title}</p>
                    </div>
                <div className="row">
                <div className="customfit-mid-edit col-12" >
                {Object.keys(customFitCategory).map((cat)=>{
                let dishId='';
                let qty=0;
                if(defaultDish[val]!==undefined && defaultDish[val][cat]!==undefined){
                    let dishVal=customfitDishsList[cat][defaultDish[val][cat]['dishId']];
                    if(dishVal!=undefined){
                    dishId={value:defaultDish[val][cat]['dishId'],label:dishVal.title};
                    qty=defaultDish[val][cat]['qty'];
                    totalprice+=defaultDish[val][cat]['price'];
                    tcalories+=this.calculateMacros((dishVal.calories/1000),qty);
                    tprotein+=this.calculateMacros((dishVal.protein/1000),qty);
                    tcarb+=this.calculateMacros((dishVal.carb/1000),qty);
                    tfat+=this.calculateMacros((dishVal.fat/1000),qty);
                    }
                }
                return <MealEdit name={customFitCategory[cat]} errors={''} dishId={dishId || '0'} qty={qty} mealType={val} catId={cat} dishList={dishList[cat]||[]} dish={customfitDishsList[cat]||[]} changeDefaultValues={this.changeDefaultValues} isEdit={false} calculateMacros={this.calculateMacros}  />
            })} {error[val]!=undefined &&<div className={'col-12'}><p style={{ fontSize: 'small',textAlign:'left',position:'relative',top:"0",color:'#d57669' }} customColor='#f44336'>{error[val]}</p></div>}
            </div></div>    
                <div className="customfit-bottom">
                    <p><span className="body-subhead-bold">{typeList[val].title} :</span> <span className={'body-subhead-small-bold'}>{totalprice.toFixed(2)} AED</span></p>
                    <p className={'font-weight-regular body-med-p'}>{this.roundUpValue(tcalories) || 0} Kcal  |  {this.roundUpValue(tprotein) || 0}g Protein  |  {this.roundUpValue(tcarb) || 0}g Carbs  |  {this.roundUpValue(tfat) || 0}g Fat</p>
                </div>
            </div>;
        });
        return (mealType && customFitCategory && <Fragment>
        {meals}
        </Fragment>);
    }
    _addExcludedWeek = (item) =>{
        item = String(item);
        const { excluded } =this.state;
        if (excluded.includes(item)) {
          this.setState({excluded:excluded.filter(
            (meal) => meal != item
          )});
        }else{
            this.setState({excluded:[...excluded,item]});
        }
      }    
    renderMealDays(){
        const { dayCount, selectedDay, excluded } =this.state;
        let mainDays =[ 
           { title:'5 Days',value:5},
           { title:'6 Days',value:6},
           { title:'20 Days',value:20},
           { title:'24 Days',value:24},
           { title:'30 Days',value:30},
           { title:'40 Days',value:40},
          //  { title:'60 Days',value:60}
        ];
        const skipdays = [ {'text':'Monday','index':1}, {'text':'Tuesday','index':2}, {'text':'Wednesday','index':3}, {'text':'Thursday','index':4}, {'text':'Friday','index':5}, {'text':'Saturday','index':6},{'text':'Sunday','index':0}];
        const daysList =[];
        for(let i=3;i<=90;i++){
            if(![5,6,20,24,30,40,60].includes(parseInt(i))){
                daysList.push({label: i+' days', value: parseInt(i)});
            }
        }
        const radioList =mainDays.map((value)=>{
            return <li><input type="radio" value={value.value} name="days" id={'label-'+value.value} checked={value.value==dayCount} onChange={(e)=>{this.setState({dayCount:parseInt(e.target.value),selectedDay:[]},() => {this.updateMealPlanId()})}} /> <label for={'label-'+value.value}>{value.title}</label></li>;
        });
        const checkBoxList =skipdays.map((value)=>{
            return <li><input type="checkbox" value={value.index} name="skipdays" id={'labelskipdays-'+value.index} checked={(excluded.includes(String(value.index)))} onChange={(e)=>{this._addExcludedWeek(e.target.value)}} /> <label for={'labelskipdays-'+value.index}>{value.text}</label></li>;
        });
     return <div className="delivery-date">
        <div className="step-form-input">
            <span className="span-label">Select No Of Days</span>
            <div className={'select-days-option day-steps'}>
              <ul className="radio-list">
              {radioList}
              </ul>
              <div className={'other-day-option'}>                
                  <div className={'className'}>
                  <Select
                      multiple={false}
                      isgrouped={true}
                    placeholder='Select Days'
                    list={daysList}
                    value={selectedDay || []}
                    isSearchable={true}
                    name='selectedDay'
                    onChange={ (name, val) => {
                    this.setState({
                    'dayCount': parseInt(val.value),
                    'selectedDay': val
                    },() => {this.updateMealPlanId()});
                    }}
                  />
                </div>
              </div>
            </div>            
        </div>        
      <div className="step-form-input">
        <h2 className="mobile-header">Select No Of Days</h2>
      <span className="span-label">Select Days to Skip</span>
        <ul className="checkbox-list skip-steps">
        {checkBoxList}
        </ul>

     </div></div>;

    }
    getPrice(){
      const priceDatas = {price:0,discountPrice:0,discountPriceCoupon:0,discountPer:0,discountType:'',discountPerCoupon:0,savedCouponAmount:0,couponCode:'',discountTypeCoupon:'',voucher_id:'',voucher_field:'',savedAmount:0};
      const { typeList } = this.props.dataArray;
      const { dayCount, defaultDish, diet, mealplanId:planId,mealType:mealTypeId,coupon, planParams,addonMealTypeList } = this.state;
      const { pricetype } = planParams;
      const customPrice = this.calcPrice(defaultDish, dayCount);
      const addOnPrice = (mealTypeId.length>0 && typeList) ? this.calcAdonPrice(diet, planId, mealTypeId.filter(val=>addonMealTypeList.includes(val.toString())), dayCount ,pricetype):0;
      const clearPrice =customPrice+addOnPrice;
      
      priceDatas.price = clearPrice;
      if('id' in coupon){
        const { type,value,code,apply_type } = coupon;
        priceDatas.couponCode=code;
        priceDatas.discountTypeCoupon=type;
        priceDatas.discountPerCoupon=(type == 'percent')?value:value/100; 
        if(apply_type=='mainprice'){
          priceDatas.discountPriceCoupon =(type == 'percent')?clearPrice-((value/100) * clearPrice):clearPrice-value;
          priceDatas.savedCouponAmount=clearPrice-priceDatas.discountPriceCoupon;
        }else{
          let { discount:discountVal,discountPer:discountPerVal, discountType:discountTypeval,voucher_id:voucherId }=this.getVoucherDiscount(clearPrice);
          priceDatas.voucher_id=voucherId;
          priceDatas.discount=discountVal;
          priceDatas.discountPer=discountPerVal;
          priceDatas.discountType=discountTypeval;
          priceDatas.discountPrice =(discountVal>0)?clearPrice - discountVal:0;
          priceDatas.savedAmount=(priceDatas.discountPrice>0)?clearPrice-priceDatas.discountPrice:0;
          let pricVal = (discountVal>0)?clearPrice - discountVal:clearPrice;
         
          priceDatas.discountPriceCoupon =(type == 'percent')?pricVal-((value/100) * pricVal):pricVal-value;
          priceDatas.savedCouponAmount=pricVal-priceDatas.discountPriceCoupon;
        }
      }else{
        
        let { discount:discountVal,discountPer:discountPerVal, discountType:discountTypeval,voucher_id:voucherId }=this.getVoucherDiscount(clearPrice);
        priceDatas.voucher_id=voucherId;
        priceDatas.discount=discountVal;
        priceDatas.discountPer=discountPerVal;
        priceDatas.discountType=discountTypeval;
        priceDatas.discountPrice=(discountVal>0)? clearPrice - priceDatas.discount:0;
        priceDatas.savedAmount=(priceDatas.discountPrice>0)?clearPrice-priceDatas.discountPrice:0;
      }
      
      
      return {addOnPrice,customPrice,clearPrice, priceDatas};
    }
    
    renderMealAddons() {
      const { dataArray } = this.props;
      const {  dayCount, mealType, addonMealTypeList,diet, mealplanId:planId,planParams } = this.state;
      const { typeList } = dataArray;
      const { pricetype } = planParams;
      const list= addonMealTypeList && typeList ? addonMealTypeList.map((item,index)=>{
              return <li className={`diet-list meal-type-l ${(mealType.includes(+item)) ? 'diet-active' : ''}`} onClick={() => this._addMealTypes(+item)}>
                 <span className={'addon_container'}>
                  <span className="addon-details-cfit">
                  <span>{typeList[item].title} </span>
                  {/* {index!=0 && typeList[item].title.indexOf('Snack')==-1 && <span>PRO {index*15}g+ :</span>}
                  {typeList[item].title.indexOf('Snack')!=-1 && <span>150Kcal - 250kcal PRO 10g+ :</span>} */}
                 </span>
                  {/* {index==2 && <span className="high-light-addon">High Protein</span>} */}
                  <strong>{(this.calcAdonPrice(diet, planId,[+item],dayCount,pricetype)/dayCount)/100} AED<span> p/day</span></strong>
                 </span>
                  <span><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM13 11H11V13C11 13.2652 10.8946 13.5196 10.7071 13.7071C10.5196 13.8946 10.2652 14 10 14C9.73479 14 9.48043 13.8946 9.2929 13.7071C9.10536 13.5196 9 13.2652 9 13V11H7C6.73479 11 6.48043 10.8946 6.2929 10.7071C6.10536 10.5196 6 10.2652 6 10C6 9.73478 6.10536 9.48043 6.2929 9.29289C6.48043 9.10536 6.73479 9 7 9H9V7C9 6.73478 9.10536 6.48043 9.2929 6.29289C9.48043 6.10536 9.73479 6 10 6C10.2652 6 10.5196 6.10536 10.7071 6.29289C10.8946 6.48043 11 6.73478 11 7V9H13C13.2652 9 13.5196 9.10536 13.7071 9.29289C13.8946 9.48043 14 9.73478 14 10C14 10.2652 13.8946 10.5196 13.7071 10.7071C13.5196 10.8946 13.2652 11 13 11Z" fill="#E3E3E3"/></svg></span>
              </li>
      }):[];
      return (list.length>0)?<div className="step-form-input">
          <span class="span-label">Preset Meals :<span>Choose if-required</span></span>          
          <ul className="checkout-diet-list add-on-list">
          {list}
      </ul></div>:'';
    }

    calcPrice = (defaultDish,daysCount) => {
        const { build } = this.props;
        if (defaultDish!=undefined && daysCount && build != 'editplan') {
            let total = 0;
              for (const outerKey in defaultDish) {
                const innerObj = defaultDish[outerKey];
                for (const innerKey in innerObj) {
                  const item = innerObj[innerKey];
                  if(item.price!=undefined){
                    const price = item.price.toFixed(2) * 100;
                    total += price;
                  }
                }
              }
          return total * Number(daysCount);
        } else if(build == 'editplan') {
          return 0;
        }else{
          return 0;
        }
      };
      calcAdonPrice = (dietId, planId, types, daysCount,pricetype=0) => {
        const { build, dataArray } = this.props;
        const { priceList } = dataArray;
        if (priceList && dietId && planId && types && build!='editplan') {
          const dayPrice = priceList
            .filter(el => +el.diet_id === +dietId && +el.mealPlan_id === +planId && types.includes(+el.mealType_id))
            .reduce((acc, cur) =>{  if(pricetype){ return acc + +cur.newValue }else{ return acc + +cur.value } }, 0);
          return dayPrice * +daysCount;
        } else if(build == 'editplan') {
          return 0;
        }else{
          return 0;
        }
      };
    renderMealServices() {
        
    }
    applyClick=()=>{
      this.props.spin();
      const { user } = this.props;
      const { couponCode } = this.state;
      const { clearPrice } = this.getPrice();
      if(clearPrice>0){
        this.props.socket.emit('mobile_checkout', { type: 'applyCouponCode',   data: {
          couponCode:couponCode,
          userId:user.user_id,
          clearPrice
        }});
      }else{
        let errorVal={};
        errorVal['couponCode']='Please select the meals and apply the code.';
        this.setState({couponCode:'',couponError:errorVal,coupon:{}});
      }
      
    }
    onChange = (name,val)=>{
      this.setState({[name]:val});
    }
    render() {
      const bagPriceOption = [
        { title: '180 AED Refundable Bag Deposit', value: 180,message:''  },
        { title: 'Renewal: already paid bag deposit', value: 0,message:'*Bag Deposit is Mandatory. If not paid, it be charged before start of the plan.' }
      ];
      const cutleryDatas =[{'title':'Yes',value:1},{'title':'No',value:0}];
      const paymentOption =[{'title':'Pay Later - Payment via online payment link to be sent later.',value:'not_paid'},
          {'title':'Payment via online',value:'paymennt'},
        ];
        const { dataArray } = this.props;
        const { dietList, typeList } = dataArray;
        
        const { diet:diet_id,mealType, defaultDish, dayCount,mealplanId, bag_price, couponCode, cutlery, paymentMethod, couponError,errors,mealTypeList,addonMealTypeList, customfitConfig } = this.state;
        const {clearPrice, addOnPrice, customPrice, priceDatas} = this.getPrice();
        const { couponCode:applyCoupon, discountPrice, discountPer,discountPriceCoupon:couponDiscount, discountPerCoupon:couponPerDiscount } = priceDatas;
        // let addAddonMealTypes =[];
        const mealTypeList1 = (mealType && typeList) ? mealType.filter(
          (meal) => mealTypeList.includes(meal.toString())
        ).map((val)=>{
          if(typeList[val].parent_id==0 || typeList[val].parent_id==null){
            const innerObj = defaultDish[val];
            let total=0;
            for (const innerKey in innerObj) {
              const item = innerObj[innerKey];
              if(item.price!=undefined){
                const price = item.price.toFixed(2) * 100;
                total += price;
              }
            }
            return {name:typeList[val].title,price:this.roundUpValue((total*dayCount))};
          }
          }).filter(n => n):[];
          const addOnList = (mealType && typeList) ? mealType.filter(
            (meal) => addonMealTypeList.includes(meal.toString())
          ).map((val)=>{
            if(typeList[val].parent_id==0 || typeList[val].parent_id==null){
              return typeList[val].title;
            }
            }).filter(n => n):[];
        const fixedPrice = (couponPerDiscount!=undefined && couponPerDiscount>0)?couponDiscount:((discountPer!=undefined && discountPer>0)?discountPrice:0);
        const totalPrice =parseInt((discountPer>0||couponPerDiscount>0)?fixedPrice:clearPrice)+parseInt(bag_price>0?bag_price*100:0);
        let props={priceDatas, dietList,subTotal:clearPrice,addOnList,addPrice:addOnPrice,mealPrice:customPrice,mealTypeList:mealTypeList1,totalPrice,days_count:dayCount, couponCode, cutlery, paymentMethod ,bagPriceOption,cutleryDatas,paymentOption,couponError,applyClick:this.applyClick,changeParams:this.onChange,savePlan:this.validate,customfitConfig}
        return <Fragment>
            <div className="main-holder checkout-process-con wrap-progress-page" >
                        <div className="container checkout-process step1">
                        <div className="row">
                        <div className='col-12'>
                          <div className="pageheader">
                            <h1>How it Works</h1>
                          </div>
                          <Tabs /></div>
                           <div className='custom-fit-checkout'>
                           <div className="col-9">
                            <div className="inner-content" id="build-meals">
                                <h2 className="mobile-header">Select Meals & Build Combinations</h2>
                                {this.renderMealBuild()}
                                {this.renderEditMeals()}
                            </div>
                            <div className="inner-content" id="build-days">
                                <h2 className="mobile-header">Select No Of Days</h2>
                                {this.renderMealDays()}
                               
                            </div>
                            <div className="inner-content" id="build-meals">
                                <h2 className="mobile-header">Add-ons:<span>Choose if-required</span></h2>
                                {this.renderMealAddons()}
                                {this.renderDates()}
                            </div>
                           
                            {/* <div className="inner-content" id="build-service">
                                <h2 className="mobile-header">Additional Service Options</h2>
                                {this.renderMealServices()}
                            </div> */}
                           </div>
                           <div className="col-3">
                              <OrderSummary {...props} />
                           </div>
                        </div>
                        </div>
                    </div>
              </div>
        </Fragment>
    }

}
Process.propTypes = {
    checkoutPlanParams: PropTypes.object.isRequired,
    checkoutMealPlan: PropTypes.object.isRequired,
    setCheckoutMealPlan: PropTypes.func.isRequired,
    setCheckoutPlanParams: PropTypes.func.isRequired,
    dataArray: PropTypes.object.isRequired
};
  
const mapStateToProps = state => ({
    checkoutPlanParams: state.checkoutPlanParams,
    dataArray: state.dataArray,
    user:state.user,
    defaultDishes: state.defaultDishes,
    customPlans: state.customPlans,
    checkoutMealPlan: state.checkoutMealPlan
});

const bindAction = dispatch => ({
    setModal: obj => dispatch(setModal(obj)),
    setCheckoutMealPlan: plan => dispatch(setCheckoutMealPlan(plan)),
    setCheckoutPlanParams: obj => dispatch(setCheckoutPlanParams(obj)),
    updateCheckoutPlanParams: obj => dispatch(updateCheckoutPlanParams(obj)),
    spin: () => dispatch(spin()),
    stop: () => dispatch(stop()),
    updateCheckoutMealPlan: (date,obj) => dispatch(updateCheckoutMealPlan(date,obj)),
    updateUser: user => dispatch(userUpdate(user))
});
  
export default socketConnect(connect(mapStateToProps, bindAction)(Process));